import { graphql, useStaticQuery } from 'gatsby'
import React, { useEffect, useState } from 'react'

import { LayoutProvider } from '@application/Contexts/LayoutContext'
import { Html } from '@application/Interfaces/Atoms/Html'
import { Link } from '@application/Interfaces/Atoms/Link'
import type { Locale } from '@application/Types/Locale'
import { Translations } from '@application/Types/TranslationTypes'
import { getLocaleCookie } from '@infrastructure/Cookies'
import { Direction } from '@mui/material'
import Container from '@mui/material/Container'
import { MAP_LOCALE_DIRECTION } from '@src/Application/Constants/languageConstants'
import { OrganizationLogo } from '@src/Application/Interfaces/Atoms/OrganizationLogo'
import { DEFAULT_DO_NOT_FOUND_TRANSALTION, PAGE_NOT_FOUND_TRANSLATION } from '@src/Core/Constants/TranslationConstants'
import { OrganizationProvider } from '@src/Infrastructure/Context/OrganizationContext'
import { Organization } from '@src/Infrastructure/Types/OrganizationType'
import { getTranslations } from '@src/templates/utils'

import { BodyContainer, Content, Description, Header, NotFoundImage, Title } from './404.styled'

const NotFoundPage = (): JSX.Element => {
    const data = useStaticQuery(graphql`
        query {
            strapiTranslation {
                ...StrapiTranslations
            }
        }
    `)

    const [direction, setDirection] = useState<Direction | undefined>(undefined)

    const translations: Translations = getTranslations(data?.strapiTranslation)

    const language = (getLocaleCookie() ?? 'en') as Locale

    const pageNotFound = translations[language]?.['pageNotFound'] ?? PAGE_NOT_FOUND_TRANSLATION

    const organization = process.env.GATSBY_ORGANIZATION as Organization
    const pageNotFoundMessage =
        translations[language]?.['pageNotFoundContent'] ?? DEFAULT_DO_NOT_FOUND_TRANSALTION[organization]

    useEffect(() => {
        setDirection(MAP_LOCALE_DIRECTION[language])
    }, [language])

    return (
        <OrganizationProvider>
            <LayoutProvider>
                <main dir={direction}>
                    <Container>
                        <Header>
                            <Link to={language === 'en' ? '/' : `/${language}/`}>
                                <OrganizationLogo mode="Light" width={200} height={29} />
                            </Link>
                        </Header>
                        <BodyContainer>
                            <NotFoundImage />
                            <Content>
                                <Title>{pageNotFound}</Title>
                                <Description>
                                    <Html content={pageNotFoundMessage} />
                                </Description>
                            </Content>
                        </BodyContainer>
                    </Container>
                </main>
            </LayoutProvider>
        </OrganizationProvider>
    )
}

export default NotFoundPage
